<template>
    <div class="tilteBox">
        <div class="title">{{titleName}}</div>
        <img src="@/assets/img/border-bottom.png" alt="">
    </div>
</template>

<script>
export default {
    props:{
        titleName:{
            type: String,
            default: ''
        }
        
    }
}
</script>

<style scoped>
.tilteBox{
    width: 100%;
    height: 32px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.title{
    font-size: 22px;
    color: #fff;
    font-family: PangMenZhengDao;
}
</style>